import {
  FilterMode,
  PublisherCollectingSociety_OrderBy,
  PublisherCollectingSociety,
  SortOrder,
  PublisherCollectingSociety_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const publisherCollectingSocietyService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.publisherCollectingSocietyOne({ id });
    return result.publisherCollectingSocietyOne as PublisherCollectingSociety;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: PublisherCollectingSociety_OrderBy[] | null = null,
    filter: PublisherCollectingSociety_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: PublisherCollectingSociety_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.publisherCollectingSocietyListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.publisherCollectingSocietyListWithOffset
    ) as PublisherCollectingSociety[];
    return { list, orderBy };
  },
};
